module.exports = __webpack_public_path__ + "03_face.56515264.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/03_face.png
// module id = fe8c
// module chunks = 0